import { configureStore } from '@reduxjs/toolkit';
import toastSlice from "./Reducer/toastReducer"
import notificationSlice from "./Reducer/notificationReducer"

export const store = configureStore({
  reducer: {
    toast: toastSlice,
    notification: notificationSlice,

  },
});